import { type Transition } from "motion/react";

export const getTradePanelTransition = (
  showTradePanel: boolean,
): Transition => ({
  type: "spring",
  stiffness: 200,
  damping: 25,
  delay: showTradePanel ? 0 : 0.1,
});
